import { useAuth0 } from '@auth0/auth0-react'
import { useMemo } from 'react'

import useSiteMetadata from '../../../hooks/useSiteMetadata'
import { parseUserCategory } from '../../../hooks/useUserCategory'
import { useCartContext } from '../../cart'
import { mapCodeFromPaymentMethod } from '../../cart/payment'
import { isTruemedAllowedUserCategory } from '../config'

export const useTruemedConfig = () => {
  const { user, isAuthenticated, isLoading: isUserLoading } = useAuth0()
  const { cart, loading: isCartLoading } = useCartContext()
  const { featureFlags } = useSiteMetadata() || {}

  const isLoading = featureFlags?.truemed ? isUserLoading || isCartLoading : false

  const isAvailable = useMemo(() => {
    if (!featureFlags?.truemed) {
      return false
    }
    if (isLoading) {
      return false
    }
    const userCategory = parseUserCategory(user)
    if (!isTruemedAllowedUserCategory(isAuthenticated, userCategory)) {
      return false
    }
    const paymentMethods = cart?.available_payment_methods ?? []
    return paymentMethods.some(
      (paymentMethod) => mapCodeFromPaymentMethod(paymentMethod?.code) === 'truemed',
    )
  }, [featureFlags?.truemed, isLoading, user, isAuthenticated, cart?.available_payment_methods])

  return { isLoading, isAvailable }
}
